<template>
  <div>
    <template>
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white black--text " @click="close"> close </v-btn>
        </v-toolbar>
      </v-card>
    </template>
    <v-card>
      <v-container class="fixWidth">
        <v-form ref="formVal" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                name="Title"
                label="Bangla Name"
                type="text"
                v-model="getSchema.institute_name_bn"
                :rules="banglaRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                name="Title"
                v-model="getSchema.institute_name_en"
                :rules="generalRules.concat(specialRules)"
              >
                <template v-slot:label>
                  English Name<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                name="Title"
                v-model="getSchema.short_name"
                :rules="generalRules.concat(specialRules)"
              >
                <template v-slot:label>
                  Short Name<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                name="Title"
                label="Website Url"
                v-model="getSchema.website_url"
                :rules="urlRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                name="Title"
                v-model.number="getSchema.eiin_no"
                :rules="generalRules.concat(numberRules)"
              >
                <template v-slot:label>
                  eiin no.<strong style="color: red">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.title"
                item-value="id"
                v-model="getSchema.institute_type_id"
                :items="getInstituteTypeItem"
                chips
                :rules="generalRules"
              >
                <template v-slot:label>
                  Institute Type<strong style="color: red">*</strong>
                </template>
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.title }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                v-model="getSchema.organization_type"
                :rules="generalRules"
                :items="organization_typeDrop"
                item-text="title"
                item-value="id"
                chips
              >
                <template v-slot:label>
                  Organization Type<strong style="color: red">*</strong>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.title"
                item-value="id"
                v-model="getSchema.education_type_id"
                :items="getEducationTypeItem"
                label="Education Type"
                chips
              >
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.title }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.en_name"
                item-value="division_code"
                v-model="getSchema.division_code"
                :items="getDivisionItem"
                label="Division Name"
                @change="searchDistrictByDivision()"
                chips
              >
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.en_name }}</span>
                  </v-chip>
                </template>
                <template v-slot:label> Division Name </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- {{getSchema.district_code}} -->
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.en_name"
                item-value="district_code"
                v-model="getSchema.district_code"
                :items="getDistrictItem"
                label="District Name"
                @change="searchThanaByDistrict()"
                :disabled="
                  getSchema.division_code == undefined ||
                  getSchema.division_code == ''
                    ? true
                    : false
                "
                chips
              >
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.en_name }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.en_name"
                item-value="thana_code"
                v-model="getSchema.thana_code"
                :items="getThanaItem"
                label="Thana Name"
                clearable
                @change="searchPostOfficeByThana()"
                :disabled="
                  getSchema.district_code == undefined ||
                  getSchema.district_code == ''
                    ? true
                    : false
                "
                chips
              >
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.en_name }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.en_name"
                item-value="post_office_code"
                v-model="getSchema.post_code"
                :items="getPostOfficeItem"
                clearable
                label="Post Office Name"
                :disabled="
                  getSchema.thana_code == undefined ||
                  getSchema.thana_code == ''
                    ? true
                    : false
                "
                chips
              >
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{ data.item.en_name }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="beside-drop-down">
              <v-text-field
                name="Title"
                label="address"
                v-model="getSchema.address"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-file-input
                id="institute-logo"
                ref="file"
                label="Upload Logo"
                accept="image/*"
                chips
                v-model="file"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            color="primary  white--text"
            @click.stop.prevent="validateBefore()"
            >{{ buttonTitle }}</v-btn
          >

          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import searchDistrictByDivision from "@/mixins/searchDistrictByDivision";
import searchThanaByDistrict from "@/mixins/searchThanaByDistrict";
import searchPostOfficeByThana from "@/mixins/searchPostOfficeByThana";
import validationRules from "../../mixins/validationRules";

export default {
  components: {},
  props: ["dialogStatus", "editedData", "indexEdited"],
  data: () => ({
    valid: null,
    loading: false,
    dialog: false,
    progressShow: false,
    file: null,
    // nameRules: [
    //   (v) => !v || /[a-zA-Z]+$/.test(v) || "Field must only contain letters",
    // ],
    // generalRules: [(v) => !!v || "This field is required"],
    // numberRule: [
    //   (v) => !v || (!isNaN(parseFloat(v)) && v >= 0) || "Number is required",
    // ],
    // banglaRules: [
    //   (v) => {
    //     for (let i = 0; i < v.length; i++) {
    //       if (
    //         v.charCodeAt(i) != 32 &&
    //         (v.charCodeAt(i) < 2433 || v.charCodeAt(i) > 2554)
    //       ) {
    //         return !v || false || "Only Bangla characters are allowed";
    //       }
    //     }
    //   },
    // ],
    // urlRules: [
    //   (v) => {
    //     let temp = v.split(".");
    //     return (
    //       !v ||
    //       (v.includes(".") &&
    //         temp.every((data) => {
    //           if (data.length == 0) {
    //             return false;
    //           } else {
    //             return true;
    //           }
    //         })) ||
    //       "The url is invalid"
    //     );
    //   },
    // ],
    organization_typeDrop: [
      {
        id: 1,
        title: "College",
      },
      {
        id: 2,
        title: "University",
      },
    ],
  }),
  async created() {
    await this.$store.dispatch("callInstituteTypeData", {
      page: 1,
      size: -1,
    });
    await this.$store.dispatch("callEducationTypeData", {
      page: 1,
      size: -1,
    });
  },
  mounted() {
    // this.$validator.localize("en", this.dictionary);
  },
  watch: {
    dialogStatus(val) {
      this.dialog = val;
      this.$store.commit("SET_INSTITUTE_SCHEMA", this.editedData);
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getDivisionItem() {
      return this.$store.getters.getDivisionItem;
    },
    getDistrictItem() {
      return this.$store.getters.getDistrictItem;
    },
    getThanaItem() {
      return this.$store.getters.getThanaItem;
    },
    getPostOfficeItem() {
      return this.$store.getters.getPostOfficeItem;
    },
    getSchema() {
      return this.$store.getters.getInstituteSchema;
    },
    searchParam() {
      return this.getSchema;
    },
    getInstituteTypeItem() {
      return this.$store.getters.getInstituteTypeItem;
    },
    getEducationTypeItem() {
      return this.$store.getters.getEduTypeItem;
    },

    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Create New Institute"
        : "Edit New Institute ";
    },
    getLoaderStatus() {
      return this.$store.getters.getLoaderStatus;
    },
  },
  mixins: [
    searchPostOfficeByThana,
    searchDistrictByDivision,
    searchThanaByDistrict,
    validationRules,
  ],
  methods: {
    handleFileUpload() {
      this.getSchema.logo = this.file;
    },
    validateBefore() {
      let valid = this.$refs.formVal.validate();
      if (valid) {
        this.validationForm();
      }
    },
    save() {
      let self = this;
      let item = this.getSchema;
      let formData = new FormData();
      if (this.getSchema.institute_name_bn)
        formData.append("institute_name_bn", this.getSchema.institute_name_bn);
      if (this.getSchema.institute_name_en)
        formData.append("institute_name_en", this.getSchema.institute_name_en);
      if (this.getSchema.short_name)
        formData.append("short_name", this.getSchema.short_name);
      if (this.getSchema.website_url)
        formData.append("website_url", this.getSchema.website_url);
      if (this.getSchema.institute_type_id)
        formData.append("institute_type_id", this.getSchema.institute_type_id);
      if (this.getSchema.organization_type)
        formData.append("organization_type", this.getSchema.organization_type);
      if (this.getSchema.education_type_id)
        formData.append("education_type_id", this.getSchema.education_type_id);
      if (this.getSchema.eiin_no)
        formData.append("eiin_no", this.getSchema.eiin_no);
      if (this.getSchema.division_code)
        formData.append("division_code", this.getSchema.division_code);
      if (this.getSchema.district_code)
        formData.append("district_code", this.getSchema.district_code);
      if (this.getSchema.thana_code)
        formData.append("thana_code", this.getSchema.thana_code);
      if (this.getSchema.post_code)
        formData.append("post_code", this.getSchema.post_code);
      if (this.getSchema.address)
        formData.append("address", this.getSchema.address);
      if (this.file) formData.append("upload_logo", this.file);

      this.$store
        .dispatch("saveInstitueData", formData)
        .then(function (data) {
          // self.progressShow = false;
          try {
            self.close();

            self.$emit("callReget", true);
          } catch (ex) {
            //  console.log(ex);
          }
        })
        .catch(function () {});
    },
    edit() {
      let self = this;
      let item = this.getSchema;
      let formData = new FormData();
      if (this.getSchema.institute_name_bn)
        formData.append("institute_name_bn", this.getSchema.institute_name_bn);
      if (this.getSchema.institute_name_en)
        formData.append("institute_name_en", this.getSchema.institute_name_en);
      if (this.getSchema.short_name)
        formData.append("short_name", this.getSchema.short_name);
      if (this.getSchema.website_url)
        formData.append("website_url", this.getSchema.website_url);
      if (this.getSchema.institute_type_id)
        formData.append("institute_type_id", this.getSchema.institute_type_id);
      if (this.getSchema.organization_type)
        formData.append("organization_type", this.getSchema.organization_type);
      if (this.getSchema.education_type_id)
        formData.append("education_type_id", this.getSchema.education_type_id);
      if (this.getSchema.eiin_no)
        formData.append("eiin_no", this.getSchema.eiin_no);
      if (this.getSchema.division_code)
        formData.append("division_code", this.getSchema.division_code);
      if (this.getSchema.district_code)
        formData.append("district_code", this.getSchema.district_code);
      if (this.getSchema.thana_code)
        formData.append("thana_code", this.getSchema.thana_code);
      if (this.getSchema.post_code)
        formData.append("post_code", this.getSchema.post_code);
      if (this.getSchema.address)
        formData.append("address", this.getSchema.address);
      if (this.file) formData.append("upload_logo", this.file);

      formData.append("_method", "PUT");
      this.$store
        .dispatch("editInstitueData", { formData: formData, id: item.id })
        .then(function (data) {
          self.close();
          self.$emit("update:loadData", true);
          self.$emit("callReget", false);
        })
        .catch(function (error) {
          //  console.log(error);
          //self.$store.dispatch("fetchCenLsDistToRegData");
        });
      this.$emit("saveText", -1);
    },

    close() {
      this.divisionSelect = true;
      this.districtSelect = true;
      this.banglaNameSelect = true;
      this.englishNameSelect = true;
      this.$store.commit("SET_LOADER", false);
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },

    validationForm() {
      return this.indexEdited === -1 ? this.save() : this.edit();
    },
    clear() {
      this.$refs.formVal.reset();
      this.getSchema.institute_name_bn = "";
      this.getSchema.institute_name_en = "";
      this.getSchema.institute_type = "";
      this.getSchema.organization_type = "";
      this.getSchema.education_type = "";
      this.getSchema.eiin_no = "";
      this.getSchema.division_code = "";
      this.getSchema.district_code = "";
      this.getSchema.thana_code = "";
      this.getSchema.post_code = "";
      this.getSchema.address = "";
      this.getSchema.website_url = "";
      this.file = null;
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.fixWidth {
  width: auto;
}
</style>
